import { BaseEntity } from './../../shared';

export class Country implements BaseEntity {
    constructor(
        public id?: number,
        public name?: string,
        public regions?: BaseEntity[],
        public organizations?: BaseEntity[],
        public users?: BaseEntity[],
        public devices?: BaseEntity[],
    ) {
    }
}
